import { eGroupSection } from "../../../store/egroups/types";
import { Component } from "react";

import Swiper, { SwiperSlideType } from "./single-section/Swiper";
import ListItem from "./single-section/List";
import { Props } from "../../propTypes";
import classnames from "classnames";
import _ from "lodash";
import Collections from "./single-section/Collections";
import { SelectedCampus } from "./single-section/types";
import Link from "next/link";

import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
type PropsParams = {
    eGroupSection: eGroupSection;
    selectedCampus: SelectedCampus | null;
};

type State = {};

export default class HomeSection extends Component<Props & PropsParams, State> {
    uuid = Date.now();

    renderLayoutList = () => {
        if (
            this.props.eGroupSection.layout === null ||
            !this.props.eGroupSection.templateEgroupSectionItems ||
            this.props.eGroupSection.templateEgroupSectionItems.length === 0 ||
            this.props.eGroupSection.templateEgroupSectionItems.filter(
                (item) => item.isActive
            ).length === 0
        ) {
            return null;
        }

        return (
            <div>
                {this.props.eGroupSection.templateEgroupSectionItems
                    .filter((item) => item.isActive)
                    .map((eGroupSectionItem, index) => {
                        if (eGroupSectionItem.layout == null) {
                            return null;
                        }

                        return (
                            <ListItem
                                key={index}
                                eGroupSectionItem={eGroupSectionItem}
                                selectedCampus={this.props.selectedCampus}
                                sectionTitle={this.props.eGroupSection?.title}
                                pageName={
                                    this.props.eGroups.eGroupHomeData?.name
                                }
                                {...this.props}
                            />
                        );
                    })}
            </div>
        );
    };

    renderLayoutSwiper = () => {
        if (
            this.props.eGroupSection.layout === null ||
            !this.props.eGroupSection.templateEgroupSectionItems ||
            this.props.eGroupSection.templateEgroupSectionItems.filter(
                (item) => item.isActive
            ).length === 0
        ) {
            return null;
        }

        let slidesPerView = 1;
        let center = false;
        const slides: SwiperSlideType[] = [];

        if (
            process.browser &&
            window.innerWidth < this.props.main.phoneMaxSize &&
            this.props.eGroupSection.layout.itemsToShowMobile
        ) {
            slidesPerView = this.props.eGroupSection.layout.itemsToShowMobile;
        } else if (
            process.browser &&
            window.innerWidth > this.props.main.phoneMaxSize &&
            this.props.eGroupSection.layout.itemsToShowDesktop
        ) {
            slidesPerView = this.props.eGroupSection.layout.itemsToShowDesktop;
        }

        this.props.eGroupSection.templateEgroupSectionItems
            .filter((item) => item.isActive)
            .sort((a, b) => a.order - b.order)
            .forEach((sectionItem) => {
                if (sectionItem.layout) {
                    let link = sectionItem.link;

                    if (link && link.includes(":campus")) {
                        if (this.props.selectedCampus) {
                            link = link.replace(
                                ":campus",
                                this.props.selectedCampus.name
                            );
                        } else {
                            link = link.replace(":campus", "");
                        }
                    }

                    if (link && link.includes(":today")) {
                        link = link.replace(
                            ":today",
                            new Date().toLocaleString("en-us", {
                                weekday: "long",
                            })
                        );
                    }

                    const slide: SwiperSlideType = {
                        link,
                        showTitle: sectionItem.layout.showTitle,
                        externalLink: sectionItem.layout.externalLink || false,
                        slideWidth: 277,
                        slideHeight: 171,
                    };

                    if (sectionItem.image) {
                        slide.image = sectionItem.image;
                    }

                    if (sectionItem.title) {
                        slide.title = sectionItem.title;
                    }

                    slides.push(slide);
                }
            });

        return (
            <Swiper
                slidesPerView={slidesPerView}
                loop={false}
                center={center}
                uuid={this.uuid.toString()}
                slides={slides}
                desktopMinSize={this.props.main.desktopMinSize}
                slideWidth={277}
                slideHeight={171}
                selectedCampus={this.props.selectedCampus?.name}
                sectionTitle={this.props.eGroupSection?.title}
                pageName={this.props.eGroups.eGroupHomeData?.name}
            />
        );
    };

    renderLayoutCollections = () => {
        if (this.props.eGroupSection.layout === null) {
            return null;
        }

        return (
            <Collections
                uuid={this.uuid.toString()}
                collections={
                    this.props.eGroups.eGroupHomeData &&
                    this.props.eGroups.eGroupHomeData.templateCollections
                }
                {...this.props}
            />
        );
    };

    render() {
        const { layout, title } = this.props.eGroupSection;

        if (layout === null || !this.props.eGroupSection.isActive) {
            return null;
        }

        let content: JSX.Element | null = null;
        switch (layout.type) {
            case "egroupList":
                content = this.renderLayoutList();
                break;
            case "swiper":
                content = this.renderLayoutSwiper();
                break;
            case "collections":
                content = this.renderLayoutCollections();
                break;
            default:
                content = null;
        }

        if (content === null) {
            return content;
        }

        return (
            <div
                className={classnames("home-section m-t-spacer-lg", {
                    [`egroups-home-swiper-${_.kebabCase(title)}`]:
                        layout.type === "swiper" ||
                        layout.type === "collections",
                    [`egroups-home-list-${_.kebabCase(title)}`]:
                        layout.type === "egroupList",
                })}
            >
                <div className="section-title flex flex-align-center flex-justify-between p-x-spacer-sm mob-p-x-spacer-md">
                    {layout.showTitle && this.props.eGroupSection.title ? (
                        <h3 className="m-y-spacer-none font-size-20">
                            {this.props.eGroupSection.title}
                        </h3>
                    ) : null}
                    {layout.showButton &&
                    layout.buttonText &&
                    this.props.eGroupSection.link ? (
                        <>
                            {layout.externalLink ? (
                                <a
                                    href={this.props.eGroupSection.link}
                                    className="text-orange hover-orange"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {layout.buttonText}
                                </a>
                            ) : (
                                <Link
                                    href={this.props.eGroupSection.link.replace(
                                        ":campus",
                                        this.props.selectedCampus &&
                                            this.props.selectedCampus.name
                                            ? this.props.selectedCampus.name
                                            : ""
                                    )}
                                >
                                    <a className="text-orange hover-orange">
                                        {layout.buttonText}
                                    </a>
                                </Link>
                            )}
                        </>
                    ) : null}
                </div>

                {this.props.eGroupSection.description &&
                layout.showDescription ? (
                    <p className="section-description m-y-spacer-none prim-font ec-text-grey font-size-18">
                        {this.props.eGroupSection.description}
                    </p>
                ) : null}
                <div
                    className={`section-content${
                        (this.props.eGroupSection.description &&
                            layout.showDescription) ||
                        (layout.showTitle && this.props.eGroupSection.title)
                            ? " m-t-spacer-none"
                            : ""
                    }`}
                >
                    {content}
                </div>
            </div>
        );
    }
}
